import ISiteMetadata from './ISiteMetadata';

export enum SystemType {
    Gen1 = 'Gen 1',
    Gen2 = 'Gen 2',
    Gen3 = 'Gen 3',
}

export enum SiteStatusType {
    Unknown = 1,
    Active = 2,
    Inactive = 3,
    Deploying = 4,
    Closed = 5
}



export default interface ISite {
    code: string;
    defaultLocale: string;

    regionId: number; // azure storage and internal region id (1 of 3)
    seoRegion: string; // public facing searchable seo regions (eg matching google geo-coding)
    country: string;
    state: string; // state/province/etc, top level catagorization within a country
    serviceArea: string; // Usually closest major city

    name: string;
    paymentLineDescription: string;
    phoneRequired: boolean;
    reservationPortal: boolean;
    groupBookingUrl: string;
    siteId: number;
    siteStatusTypeId: SiteStatusType;
    siteMetadata: ISiteMetadata;
    systemType: string;
    urlKey: string;
    hasGroupBookings: boolean;
    externalBookingUrl: string;
    useExternalBookingUrl: boolean;
    excludeExternalBookingDecoration: boolean;
    // True when this venue was revealed/authorised via a matching preview access code in the URL.
    // Lets pre-launch venues be booked in-app and suppresses the 3rd-party booking redirect.
    previewAccess?: boolean;
    maximumPlayers: number;
    hasPrivateSessions: boolean;
    importantInfoAlert: string;
    faqUrl: string;
    bookingAlert: string;
    showTaxAmountWhenBooking: boolean;
    groupBookingMessageOption: number;
    giftVouchersAvailable: boolean;
    currencySymbol: string;
    paypalCode: string;
    currencyId: number;
    taxPercentage: number;
    useBraze?: boolean;
}
